import { createFileRoute } from '@tanstack/react-router';
import { requireSession } from '../lib/authGuard';
import { redirectFromSelector } from '@/app/entry/portalGuards';
import { RoleSelector } from '@/app/entry/RoleSelector';

// Selector de portal, standalone y sin shell. Con 0 o 1 portales no se muestra: redirige.
export const Route = createFileRoute('/select-role')({
    beforeLoad: async ({ context, location }) => {
        await requireSession(context.auth, location.pathname);
        await redirectFromSelector(context.auth);
    },
    component: RoleSelector,
});
